import { render } from "./ThankYou.vue?vue&type=template&id=b7cacd70&scoped=true"
import script from "./ThankYou.vue?vue&type=script&lang=js"
export * from "./ThankYou.vue?vue&type=script&lang=js"

import "./ThankYou.vue?vue&type=style&index=0&id=b7cacd70&scoped=true&lang=css"

import exportComponent from "/var/www/zaytoon-sudani-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b7cacd70"]])

export default __exports__